export enum AutoLoanPaymentMethodAction {
  EDIT_VEHICLE_DATA = 'EDIT_VEHICLE_DATA',
  EDIT_FINANCING_DETAILS = 'EDIT_FINANCING_DETAILS',
}
